import React from 'react';
import * as S from '../Checkbox/Checkbox.styles';
import Icon from '../IconsSelector';
import CustomRadioButton from '../CustomRadioButtonUI/CustomRadioButtonUI';
import { LanguageOptions } from '../../components/cars/reviewpage/OsAddons/OsAddon';

type Checkboxprops = {
  title       : string;
  name       ?: string;
  isIcon     ?: boolean;
  onClickCb  ?: Function;
  checked    ?: boolean;
  data       ?: string
  subtitle   ?: string
  suffixText ?: string
  infoText   ?: string
  options    ?: LanguageOptions[]
  handleLangaueClick: (id: string) => void
  selectedLanguage: string
  showLoader: boolean
};

const CustomCheckbox = ({
  title,
  name,
  isIcon,
  onClickCb,
  checked,
  data = "",
  subtitle,
  suffixText,
  infoText,
  options,
  handleLangaueClick,
  selectedLanguage,
  showLoader,
}: Checkboxprops) => {

  const handleOptionClick = (event: React.ChangeEvent<HTMLInputElement>, id: string) => {
    event.stopPropagation();
    event.preventDefault();
    handleLangaueClick && handleLangaueClick(id);
  }

  return (
    <S.CheckBoxLabel
      isIcon={isIcon}
      alignItems={subtitle?.length && suffixText?.length ? 'flex-start' : 'center'}
      showLoader={showLoader}
    >
    <S.CheckBoxContainer>
      <S.CheckBox type="checkbox" checked={checked} onChange={() => onClickCb(data)} />
      {!showLoader && <S.Checkmark marginTop={subtitle?.length && suffixText?.length ? '4px' : '0'}></S.Checkmark>}
      {showLoader && <S.Loader />}
    </S.CheckBoxContainer>
    <div>
      {(isIcon && (
        <S.CheckboxIcon>
          <Icon name={name}></Icon>
        </S.CheckboxIcon>
      )) ||
        ''}
      <S.TitleSubtitleCont showLoader={showLoader}>
        {title?.length ? <S.CheckboxText title={title} fontWeight={subtitle?.length && suffixText?.length ? '600' : '400'}>{title}</S.CheckboxText> : null}
        {subtitle?.length ? <S.CheckboxSubtitle>{subtitle}</S.CheckboxSubtitle> : null}
        {checked && options?.length && selectedLanguage &&  (
          <S.OptionContainer>
            {options.map((option, index) => (
              <S.OptionsCont key={index} onClick={(event) => handleOptionClick(event, option.id)}>
                <CustomRadioButton
                  isActive={option.id === selectedLanguage}
                  backgroundColor={"#2276e3"}
                  borderColor={"#2276e3"}
                />
                <S.Option>{option.title}</S.Option>
              </S.OptionsCont>
            ))}
          </S.OptionContainer>
        )}
        {infoText?.length ? <S.InfoText>{infoText}</S.InfoText> : null}
      </S.TitleSubtitleCont>
    </div>
      {suffixText?.length ? <S.CheckboxSuffix showLoader={showLoader}>{suffixText}</S.CheckboxSuffix> : null}
    </S.CheckBoxLabel>
   )
};

export default CustomCheckbox;
